import { AccessToken } from "@clairejs/core";

export abstract class AbstractTokenManager {
    abstract getAccessToken(): Promise<AccessToken | undefined>;
    abstract setAccessToken(token?: AccessToken): Promise<void>;
}
